import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiClient } from '@services/apiClient';

import { whatsNewListKey } from './useWhatsNewListInfiniteQuery';

interface IData {
  newsId: number;
  isFavorite: boolean;
}

const whatsNewToggleFavoriteFn = (data: IData) => {
  const { newsId, isFavorite } = data;

  const params = {
    newsId,
    isMarked: +isFavorite,
  };

  return apiClient.post(`${APP_API_URL_V2}customer-dashboard-v2/whats-new/toggle-favorite`, params);
};

export const useWhatsNewToggleFavoriteMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: whatsNewToggleFavoriteFn,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [whatsNewListKey({})[0]] });
    },
  });
};
